<template>
    <div id="modal-editor-download-image">
        <div class="rp-overlay"></div>
        <div class="rp-modal" style="width: 470px;">
            <div class="rp-modal-header">
                <h3 class="rp-modal-title">{{ $t('Download image') }}</h3>
                <button class="rp-btn-dismiss" @click="$emit('closeModal')">
                    <XIcon class="w-5 h-5" />
                </button>
            </div>
            <div class="bg-white p-5">
                <div class="mb-4">
                    <div class="text-base font-medium">{{ $t('Download options') }}</div>
                </div>
                <div class="mb-6">
                    <div class="flex items-center">
                        <input type="checkbox" id="download-with-mask" v-model="layout.downloadMask" class="rounded border-gray-300 text-primary-600 h-5 w-5">
                        <label for="download-with-mask" class="ml-2 text-gray-700">{{ $t('Download with mask') }}</label>
                    </div>
                </div>
                <div class="rp-modal-body-buttons gap-3 mt-4">
                    <button class="rp-btn-secondary" @click="$emit('closeModal')">
                        {{ $t('Cancel') }}
                    </button>
                    <button class="rp-btn-primary" @click="downloadImage()">
                        {{ $t('Download') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref }       from "vue";
import { helper as $helper }    from "@/utils/helper";
import { fabric }               from 'fabric';

const emit = defineEmits(['closeModal']);

const props = defineProps({
    image: {
        type: Object,
        required: true
    },
    canvas: {
        type: Object,
        required: true
    }
});

const layout = ref({
    image:          {},
    canvas:         {},
    downloadMask:   false
});

const downloadImage = async () => {
    let imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'tiff', 'webp'];
    const img = layout.value.image;

    if (!img) {
        return;
    }

    let imgCanvas 		= new fabric.Canvas('canvas');
    let imageObject 	= layout.value.canvas.find(obj => obj.type === 'image');
    let canvasObjects 	= layout.value.canvas.filter(obj => obj.type !== 'image');
    
    imgCanvas.setWidth(imageObject.width);
    imgCanvas.setHeight(imageObject.height);
    imgCanvas.add(imageObject);

    if (layout.value.downloadMask) {
        canvasObjects.forEach(obj => {
            imgCanvas.add(obj);
        })
    }

    let filename = img.name.substr(img.name.lastIndexOf("/") + 1);
    let hasImageExtension = imageExtensions.some(ext => filename.toLowerCase().endsWith('.' + ext));
    filename = hasImageExtension ? filename : filename + '.png';

    let link = document.createElement('a');
    link.href = imgCanvas.toDataURL();
    link.download = filename;
    link.click();

    emit('closeModal');
    $helper.NotificationTxt({ text: 'The download will start automatically', position: "center" });
}

onMounted(() => {
    if (props.image) {
        layout.value.image = props.image;
    }
    if (props.canvas) {
        layout.value.canvas = props.canvas;
    }
});
</script>